import { normalizeTrackingDomainUuids } from './trackingQuery'

export const DEFAULT_DOMAIN_LAUNCH_DATE = '2020-01-01'

const ISO_DATE_PATTERN = /^(\d{4}-\d{2}-\d{2})/

export function normalizeDomainLaunchDate (value) {
  if (typeof value !== 'string') {
    return null
  }

  const match = value.match(ISO_DATE_PATTERN)
  return match ? match[1] : null
}

export function getDomainPeriodStartDate (domain) {
  return normalizeDomainLaunchDate(domain?.launch_date) || DEFAULT_DOMAIN_LAUNCH_DATE
}

export function getTrackingPeriodStartDate (domains, selectedDomainUuids) {
  const domainList = Array.isArray(domains) ? domains : []
  const selectedUuids = new Set(normalizeTrackingDomainUuids(selectedDomainUuids))
  const scopedDomains = selectedUuids.size > 0
    ? domainList.filter(domain => selectedUuids.has(domain?.uuid))
    : domainList

  return scopedDomains.reduce((earliestDate, domain) => {
    const startDate = getDomainPeriodStartDate(domain)
    return !earliestDate || startDate < earliestDate ? startDate : earliestDate
  }, null) || DEFAULT_DOMAIN_LAUNCH_DATE
}

export function getFullTrackingDateRange (domains, selectedDomainUuids, today = new Date()) {
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  const endDate = `${year}-${month}-${day}`
  const startDate = getTrackingPeriodStartDate(domains, selectedDomainUuids)

  return [
    startDate > endDate ? endDate : startDate,
    endDate
  ]
}
